// extracted by mini-css-extract-plugin
export var container = "heroDetail-module--container--b4d90";
export var container_text = "heroDetail-module--container_text--877cb";
export var container_title = "heroDetail-module--container_title--5f717";
export var container_variants = "heroDetail-module--container_variants--5636a";
export var heroDetail = "heroDetail-module--heroDetail--8703b";
export var heroDetail__variants = "heroDetail-module--heroDetail__variants--9b8f0";
export var main_container = "heroDetail-module--main_container--6fa28";
export var title = "heroDetail-module--title--cc19c";